const binding = { modules: {}, dataActions: {} };

    (binding.modules['moe-v2-file-download'] = {
        c: () => require('partner/modules/moe-v2-file-download/moe-v2-file-download.tsx'),
        $type: 'contentModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'moe-v2-file-download',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/moe-v2-file-download'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|moe-v2-file-download|moe-v2-file-download'] = {
                c: () => require('partner/modules/moe-v2-file-download/moe-v2-file-download.view.tsx'),
                cn: '__local__-__local__-moe-v2-file-download'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };